import { Accessibility, Loader2, Send } from "lucide-react";

export const emptyAdaRequest = (extra = {}) => ({
    category: "cognitive",
    functional_need: "",
    requested_accommodation: "",
    ...extra,
});

export function validateAdaRequest(value) {
    if (!value?.category) return "Select a disability-access category.";
    if (!(value.functional_need || "").trim()) return "Describe the access barrier or functional need.";
    if (!(value.requested_accommodation || "").trim()) return "Describe the accommodation being requested.";
    return "";
}

export function AdaRequestForm({ meta, value, onChange, onSubmit, busy = false, disabled = false,
    testPrefix = "ada-request", submitLabel = "Submit ADA request", showDate = false, staffLinks = false }) {
    const details = meta?.category_details?.[value.category];
    const categories = Object.entries(meta?.categories || {});
    const categoriesReady = categories.length > 0;
    const setField = (key, next) => onChange({ ...value, [key]: next });

    return (
        <div data-testid={`${testPrefix}-form`} className="space-y-3">
            <div className="flex items-center gap-2 text-sm font-semibold text-phoenix-navy">
                <Accessibility className="w-4 h-4" /> Disability access request
            </div>
            <div>
                <label className="text-xs font-semibold text-muted-foreground">Disability / access category</label>
                <select data-testid={`${testPrefix}-category`} value={value.category}
                    onChange={(e) => setField("category", e.target.value)}
                    disabled={!categoriesReady}
                    className="w-full mt-1 px-3 py-2 border border-border rounded-lg text-sm bg-white">
                    {!categoriesReady && <option value={value.category}>Loading categories…</option>}
                    {categories.map(([key, label]) => <option key={key} value={key}>{label}</option>)}
                </select>
                {details?.help && <p data-testid={`${testPrefix}-category-help`} className="text-[11px] text-muted-foreground mt-1">{details.help}</p>}
            </div>
            <div>
                <label className="text-xs font-semibold text-muted-foreground">Access barrier or functional need</label>
                <textarea data-testid={`${testPrefix}-functional-need`} rows={2} value={value.functional_need}
                    onChange={(e) => setField("functional_need", e.target.value)}
                    className="w-full mt-1 px-3 py-2 border border-border rounded-lg text-sm"
                    placeholder="What activity, communication, housing area, program, or daily task is difficult to access?" />
            </div>
            <div>
                <label className="text-xs font-semibold text-muted-foreground">Accommodation requested</label>
                <textarea data-testid={`${testPrefix}-requested-accommodation`} rows={2} value={value.requested_accommodation}
                    onChange={(e) => setField("requested_accommodation", e.target.value)}
                    className="w-full mt-1 px-3 py-2 border border-border rounded-lg text-sm"
                    placeholder="What modification, assistance, equipment, format, or access support is requested?" />
            </div>
            {showDate && (
                <div>
                    <label className="text-xs font-semibold text-muted-foreground">Requested on</label>
                    <input data-testid={`${testPrefix}-requested-at`} type="date" value={value.requested_at || ""}
                        onChange={(e) => setField("requested_at", e.target.value)}
                        className="w-full mt-1 px-3 py-2 border border-border rounded-lg text-sm" />
                </div>
            )}
            <button type="button" data-testid={`${testPrefix}-submit`} onClick={onSubmit} disabled={busy || disabled || !categoriesReady}
                className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg bg-phoenix-navy text-white text-sm font-semibold hover:bg-phoenix-navy/90 disabled:opacity-50">
                {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} {submitLabel}
            </button>
        </div>
    );
}